import { render, staticRenderFns } from "./BeefCattleSmallList32023.vue?vue&type=template&id=baa7ae32&scoped=true"
import script from "./BeefCattleSmallList32023.vue?vue&type=script&lang=js"
export * from "./BeefCattleSmallList32023.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleSmallList32023.vue?vue&type=style&index=0&id=baa7ae32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa7ae32",
  null
  
)

export default component.exports